import { type ComponentPropsWithRef, type ReactNode, useMemo } from 'react';
import styled from 'styled-components';

import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

type Props = ComponentPropsWithRef<'div'> & {
  children: ReactNode;
  type?: 'feedback' | 'topics' | 'ai-topics';
  inActive?: boolean;
  onClick?: () => void;
};

const TicketLabel = (props: Props) => {
  const color = useColor();

  const { type, inActive, style, children, ...rest } = props;

  const themeColor = useMemo(() => {
    if (type === 'feedback')
      if (inActive)
        return {
          border: `1px dashed ${color.orange(0.8)}`,
          color: color.orange(0.8),
        };
      else
        return {
          color: color.orange(0.8),
          backgroundColor: color.orange(0.04),
          border: `1px solid ${color.orange(0.05)}`,
        };

    if (type === 'topics') {
      return {
        color: color.primary100,
        backgroundColor: color.primaryAlpha(0.04),
        border: `1px solid ${color.primaryAlpha(0.05)}`,
      };
    }

    if (type === 'ai-topics') {
      return {
        color: color.green500,
        backgroundColor: color.green(0.04),
        border: `1px solid ${color.green(0.05)}`,
      };
    }

    return {
      color: color.primaryAlpha(0.8),
      backgroundColor: color.primaryAlpha(0.04),
      border: `1px solid ${color.primaryAlpha(0.05)}`,
    };
  }, [type, inActive, color]);

  return (
    <TicketLabelStyle style={{ ...themeColor, ...style }} {...rest}>
      <Typo type="label3">{children}</Typo>
    </TicketLabelStyle>
  );
};

export const TicketLabelStyle = styled.span`
  width: fit-content;
  font-size: 14px;
  padding: 1px 5px;
  border-radius: 4px;
  white-space: nowrap;
  font-weight: 500;
`;

export default TicketLabel;
